import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import * as Yup from 'yup';

import sampleCsv from '../../../../assets/Csvs/Sample-outlet.csv';
import { beatOptionsGet, outletUpload } from '../../../../store/slices/tenantSlices/productSlice';
import FormSelect from '../../../../components/form/FormSelect';

const ImportOutletModal = ({ isOpen, onCloseClick }) => {
  const dispatch = useDispatch();

  const [beatOption, setBeatOption] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = { file: '', beat_id: '' };

  const validationSchema = Yup.object({
    file: Yup.string().required('File is required'),
    beat_id: Yup.string().required('Beat is required')
  });

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('file', values.file);
      const response = await dispatch(outletUpload(formData)).unwrap();
      if (response?.message) {
        toast.success('File Imported Successfully');
        onCloseClick(true);
        resetForm();
      } else {
        toast.error(response.error || 'An error occurred during the upload');
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Error in file upload', error);
      toast.error('An error occurred during the upload');
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    handleSubmit,
    resetForm,
    setFieldValue
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  const getBeatOption = async () => {
    try {
      const response = await dispatch(beatOptionsGet()).unwrap();
      if (response && response.data) {
        const options = response.data.map((val) => ({
          label: val.name,
          value: val.id
        }));
        setBeatOption(options);
      } else {
        setBeatOption([]);
      }
    } catch (error) {
      setBeatOption([]);
      console.log('error', error);
    }
  };

  useEffect(() => {
    getBeatOption();
  }, []);

  return (
    <Modal isOpen={isOpen} size="lg" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">Import Outlet</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="dnc" onSubmit={handleSubmit}>
          <Row>
            <Col lg="6">
              <FormSelect
                name="beat_id"
                label="Beat"
                placeholder="Select beat"
                value={values.beat_id}
                options={beatOption}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="6">
              <FormGroup>
                <Label htmlFor="file-upload">File</Label>
                <div className="file-upload-container cursor-pointer">
                  <Input
                    type="text"
                    className="file-name cursor-pointer"
                    placeholder={values.file?.name || 'Choose a file'}
                    readOnly
                  />
                  <label className="upload-button cursor-pointer">
                    <Icon.Upload size={18} className="cursor-pointer" />
                    <Input
                      type="file"
                      id="file-upload"
                      className="file-upload cursor-pointer"
                      accept=".csv"
                      onChange={(e) => setFieldValue('file', e.target.files[0])}
                    />
                  </label>
                </div>
              </FormGroup>
            </Col>
          </Row>
          {/* Add message for downloading sample CSV */}
          <Row>
            <Col lg="12">
              <p className="text-muted">
                Don't have a file? You can{' '}
                <a href={sampleCsv} download className="link-primary">
                  download a sample CSV
                </a>
                .
              </p>
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button
          form="dnc"
          type="submit"
          className="px-5 bg-primary border-primary d-flex justify-content-center align-items-center gap-2">
          Upload
          {isLoading ? <Spinner size="sm" color="light" /> : null}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ImportOutletModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired
};

export default ImportOutletModal;
